module.exports = __webpack_public_path__ + "img/flag.25bf6800.png";